import { Box, Container, Stack } from '@mui/material';

import { Login as LoginView } from '@modules/Auth/views';

export const Login = () => {

  return (
    <Stack height="100vh" justifyContent="center">
      <Box py={6}>
        <Container maxWidth="md">
          <LoginView />
        </Container>
      </Box>
    </Stack>
  );
};
